<template>
	<div class="member">
		<h2 v-if="flag == '1'" class="member-t">选择<span class="font-red">适合版本</span></h2>
		<p v-if="flag == '1'" class="member-p">年度购买基础版提供电子版，专业版加送视频教程，企业版额外附赠实体书籍，从新手到专家的全阶段学习资源。</p>
		<h2 v-if="flag == '2'" class="member-t">先体验再加盟</h2>
		<p v-if="flag == '2'" class="member-p">专业的寄售与回收业务管理工具，助力商户高效运营</p>
		<div class="member-img">
			<div class="member-img-item">
				<img class="top-img" src="../../static/home/top2-img.png" alt="" />
				<div class="top-tit">
					<div class="title saas-tit2">免费版</div>
					<div class="flex">
						<div class="flex-1">免费体验、线上化办单全流程</div>
						<div class="top-price">
							<div class="price">
								<span>¥</span>
								<span class="amount">0</span>
							</div>
							<div class="price-t">席位/月</div>
						</div>
					</div>
				</div>
				<div class="menber-btn menber-btn2" @click.stop="openCode()">立即开通</div>
				<div class="member-list">
					<div v-for="(item, i) in memberList2" :key="i" class="member-list-item">
						<div class="left">
							<img class="tick-img" src="../../static/home/tick1.png" alt="" />
							<span>{{ item.name }}</span>
						</div>
						<div class="right">{{ item.title }}</div>
					</div>
				</div>
			</div>
			<div class="member-img-item">
				<img class="top-img" src="../../static/home/top4-img.png" alt="" />
				<div class="top-tit">
					<div class="title saas-tit4">企业版<span class="title-tip">二年/9.5折</span></div>
					<div class="flex">
						<div class="flex-1">规模化、定制化和企业化运营</div>
						<div class="top-price">
							<div class="price">
								<span>¥</span>
								<span class="amount">2400</span>
							</div>
							<div class="price-t">席位/年</div>
						</div>
					</div>
				</div>
				<div class="menber-btn menber-btn4" @click.stop="openCode()">立即开通</div>
				<div class="member-list">
					<div v-for="(item, i) in memberList4" :key="i" class="member-list-item">
						<div class="left">
							<img class="tick-img" src="../../static/home/tick1.png" alt="" />
							<span>{{ item.name }}</span>
						</div>
						<div class="right">{{ item.title }}</div>
					</div>
				</div>
			</div>
		</div>
		<ConsultDialog v-if="centerDialogVisible" @close="close"></ConsultDialog>
	</div>
</template>

<script>
	import ConsultDialog from './ConsultDialog.vue'
	export default {
		props: {
			flag: {
				type: String,
				default: '1'
			}
		},
		components: {ConsultDialog},
		data() {
			return {
				memberList2: [
					{name: '门店品牌加持', title: ''},
					{name: '估价系统 1次/日', title: ''},
					{name: '合同立项 5单/月', title: ''},
					{name: '订单管理', title: ''},
					{name: '财务审批', title: ''},
					{name: '智能计算器', title: ''},
					{name: '云铺商城', title: ''},
					{name: '订单资料云储存', title: ''},
					{name: '线上交易服务费1%', title: ''},
				],
				memberList4: [
					{name: '门店入驻', title: ''},
					{name: '品牌宣传', title: ''},
					{name: '估价系统 不限次数', title: ''},
					{name: '合同立项 不限次数', title: ''},
					{name: '汽车系统', title: ''},
					{name: '电子合同', title: ''},
					{name: '订单管理', title: ''},
					{name: '费用标准', title: ''},
					{name: '仓储管理', title: ''},
					{name: '财务报表', title: ''},
					{name: '延期提醒', title: ''},
					{name: '云铺商城', title: ''},
					{name: '订单云存储', title: ''},
					{name: '交易费0.6%', title: ''},
				],
				centerDialogVisible: false,
			}
		},
		methods: {
			close(flag) {
				this.centerDialogVisible = false
			},
			openCode() {
				this.centerDialogVisible = true
			},
		}
	}
</script>

<style scoped>
	.member {
		width: 1200px;
		margin: 0 auto;
		margin-top: 100px;
		/* margin-bottom: 15px; */
		padding-bottom: 70px;
	}
	.member-t {
		font-weight: 600;
		font-size: 40px;
		color: #333333;
		text-align: center;
	}
	.member-p {
		font-weight: 600;
		font-size: 14px;
		color: #999999;
		margin-bottom: 80px;
		text-align: center;
	}
	.member-img {
		display: flex;
		align-items: stretch;
		justify-content: space-between;
	}
	.member-img-item {
		width: 49%;
		display: flex;
		flex-direction: column;
		background: #FFFFFF;
		border-radius: 15px;
		box-shadow: 0px 14px 27px 0px rgba(231,231,231,0.45);
	}
	.member-img-item .top-tit .flex-1 {
		min-width: 0;
		word-break: break-word;
		overflow-wrap: break-word;
	}
	.member-img-item .top-img {
		width: 100%;
		height: 10px;
		vertical-align: top;
	}
	.member-img-item .top-tit {
		font-weight: 600;
		font-size: 14px;
		color: #333333;
		padding: 0 30px;
		margin-top: 20px;
		margin-bottom: 20px;
	}
	.member-img-item .top-tit .title {
		font-size: 30px;
	}
	.member-img-item .top-tit .title .title-tip {
		font-size: 12px;
		color: #FFFFFF;
		margin-left: 6px;	
		height: 14px;
		background: #FFBD42;
		border-radius: 2px;
		padding: 1px 3px;
	}
	.member-img-item .top-tit .saas-tit1 {
		color: #3F575F;
	}
	.member-img-item .top-tit .saas-tit2 {
		color: #B25F05;
	}
	.member-img-item .top-tit .saas-tit3 {
		color: #9D3002;
	}
	.member-img-item .top-tit .saas-tit4 {
		color: #006CDF;
	}
	.title-tip1 {
		background: #1684FC !important;
	}
	.title-tip2 {
		background: #FE3D3A !important;
	}
	.member-img-item .top-price {
		display: flex;
		align-items: center;
		font-size: 16px;
		color: #333333;
		padding: 0 30px;
	}
	.member-img-item .top-price .price {
		flex: 1;
	}
	.member-img-item .top-price .price .amount {
		font-weight: 600;
		font-size: 40px;
	}
	.member-img-item .top-price .price-t {
		margin-top: 12px;
	}
	.menber-btn {
		height: 50px;
		line-height: 50px;
		border-radius: 30px;
		font-weight: 500;
		font-size: 20px;
		text-align: center;
		margin: 10px 20px 30px;
	}
	.menber-btn1 {
		color: #3F575F;
		border: 1px solid #3F575F;
	}
	.menber-btn2 {
		color: #333333;
		background: linear-gradient( 141deg, #FEEAC1 0%, #FFCA74 100%), #B25F05;
	}
	.menber-btn3 {
		color: #333333;
		background: linear-gradient( 141deg, #FBD7C1 0%, #F99864 100%);
	}
	.menber-btn4 {
		color: #333333;
		background: linear-gradient( 135deg, #D4EEFF 0%, #74C8FF 100%);
	}
	.member-img-item .member-list {
		flex: 1;
		display: grid;
		grid-template-columns: 1fr 1fr;
		grid-template-rows: repeat(7, auto);
		grid-auto-flow: column;
		align-content: flex-start;
		column-gap: 10px;
		padding: 0 30px 10px;
	}
	.member-img-item .member-list .member-list-item {
		box-sizing: border-box;
		display: flex;
		align-items: flex-start;
		font-size: 14px;
		color: #333333;
		padding-bottom: 15px;
	}
	.member-list .member-list-item .left {
		width: 100%;
		min-width: 0;
		display: flex;
		flex-wrap: wrap;
		align-items: flex-start;
		font-weight: 600;
		word-break: break-word;
		overflow-wrap: break-word;
		line-height: 1.5;
	}
	.member-list .member-list-item .left span {
		flex: 1;
		min-width: 0;
		word-break: break-word;
		overflow-wrap: break-word;
	}
	.member-list .member-list-item .right {
		flex: 1;
		min-width: 0;
		font-weight: 400;
		word-break: break-word;
		overflow-wrap: break-word;
	}
	.member-list .member-list-item .tick-img {
		flex-shrink: 0;
		width: 13px;
		height: 10px;
		margin-right: 10px;
		margin-top: 4px;
	}
	.member-list .member-list-item .service-fee {
		width: 100%;
		padding-left: 23px;
		font-size: 12px;
		font-weight: 400;
		color: #666666;
		word-break: break-word;
		overflow-wrap: break-word;
	}
	.font-color-tick1 {
		color: #3F575F;
	}
	.font-color-tick2 {
		color: #B25F05;
	}
	.font-color-tick3 {
		color: #9D3002;
	}
</style>


// WEBPACK FOOTER //
// src/components/Saas.vue